export default __webpack_public_path__ + "static/media/LoginBackground.983b3ebd.png";